import React from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import Footer from './Footer';

const Layout = (props) => {

    // Check if the current path should hide the navbar
    return (
        <div>
            <NavMenu />
            <div className = "content-container">
                <Container>
                    {props.children}
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default Layout;
